import { Col, Divider, Row } from "antd";
import { Content } from "antd/lib/layout/layout";
import ReactWhatsapp from "react-whatsapp";
import React from "react";
import FeaturedCarousel from "./FeaturedCarousel";
import RecentProject from "./RecentProject";
import * as img from "./img";
import { motion } from "framer-motion";
import BacktoTop, { backtoTopFunction } from "./components/BacktoTop";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CoupleSession from "./works";
import { useNavigate } from "react-router-dom";

const FeaturedPage = () => {
  backtoTopFunction();
  const navigate = useNavigate();
  return (
    <>
      <FeaturedCarousel />
      <motion.div
        initial={{ x: 0, opacity: 0 }}
        transition={{ ease: "easeIn", duration: 0.8 }}
        whileInView={{ opacity: [0, 1], x: [-100, 0] }}
      >
        <Content
          className="site-layout"
          // style={{ padding: windowspadding()}}
        >
          <div
            className="site-layout-background center-img-grid"
            // className= {window.innerWidth > 450 ? "site-layout-background center-img-grid" : "site-layout-background"}
            // style={{ padding: "20px", minHeight: 380, width: windowswidth() }}
          >
            {window.innerWidth > 600 ? (
              <Divider orientation="left">
                <h1>Expertise in Interior Architecture :</h1>
              </Divider>
            ) : (
              <h1>Expertise in Interior Architecture :</h1>
            )}
            <Row>
              <Col
                span={7}
                xs={{ order: 1 }}
                sm={{ order: 2 }}
                md={{ order: 3 }}
                lg={{ order: 4 }}
                style={{ border: "solid 1px" }}
              >
                <img src={img.logo} className="imgprofile" alt="noImg" />
              </Col>
              <Col
                span={16}
                xs={{ order: 2 }}
                sm={{ order: 1 }}
                md={{ order: 4 }}
                lg={{ order: 3 }}
                // style={{ border: "solid 1px" }}
              >
                <h2>
                  Design things for 14 years <br />
                </h2>
                <h3>
                  I've worked with a wide array of clients, and created dozens
                  of different spaces in various shapes and sizes.
                </h3>
              </Col>
            </Row>

            <hr />
            <Row>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9, zIndex: 1 }}
              >
                <ReactWhatsapp
                  number="+6281293935775"
                  message="Hi,I'm interested in your project"
                  element="a"
                >
                  <b>Contact me on Whatsapp !</b>
                </ReactWhatsapp>
                <img src={img.wa} alt="noImg" style={{ width: "10%" }} />
              </motion.div>
            </Row>
            {/* <Row>
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9, zIndex: 1 }}
              >
                <ReactWhatsapp
                  number="+6281293935775"
                  message="Hi,I'm interested in your project"
                  element="a"
                >
                  <b>Contact me on Whatsapp !</b>
                </ReactWhatsapp>
                <img src={img.wa} alt="noImg" style={{ width: "10%" }} />
              </motion.div>
            </Row> */}
            <Row>
              <p>Email me at : </p>{" "}
            </Row>
            <Row>
              <motion.div
                whileHover={{ scale: 1.1, x: 10 }}
                whileTap={{ scale: 0.9, zIndex: 1 }}
              >
                <p
                  style={{ color: "rgba(15, 43, 222, 0.8)" }}
                  onClick={() => {
                    navigator.clipboard.writeText("inggriany.only@gmail.com");
                    toast.success("Email Copied!", {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                    });
                  }}
                >
                  <b>inggriany.only@gmail.com</b>
                </p>
              </motion.div>
            </Row>
          </div>
        </Content>
      </motion.div>

      <Content className="site-layout">
        <RecentProject />
      </Content>
      <BacktoTop />
    </>
  );
};

export default FeaturedPage;
